// import parseTime, formatTime and set to filter
import { decryptionStr } from '@/utils/crypto'
export {
	parseTime,
	formatTime
}
	from '@/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize (time, label) {
	if (time === 1) {
		return time + label
	}
	return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo (time) {
	const between = Date.now() / 1000 - Number(time)
	if (between < 3600) {
		return pluralize(~~(between / 60), ' minute')
	} else if (between < 86400) {
		return pluralize(~~(between / 3600), ' hour')
	} else {
		return pluralize(~~(between / 86400), ' day')
	}
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter (num, digits) {
	const si = [{
		value: 1e18,
		symbol: 'E'
	},
	{
		value: 1e15,
		symbol: 'P'
	},
	{
		value: 1e12,
		symbol: 'T'
	},
	{
		value: 1e9,
		symbol: 'G'
	},
	{
		value: 1e6,
		symbol: 'M'
	},
	{
		value: 1e3,
		symbol: 'k'
	}
	]
	for (let i = 0; i < si.length; i++) {
		if (num >= si[i].value) {
			return (
				(num / si[i].value)
					.toFixed(digits)
					.replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
			)
		}
	}
	return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter (num) {
	return (+num || 0)
		.toString()
		.replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst (string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}
export const toDecimal2 = x => {
	let f = parseFloat(x)
	if (isNaN(f)) {
		return false
	}
	f = Math.round(x * 100) / 100
	let s = f.toString()
	let rs = s.indexOf('.')
	if (rs < 0) {
		rs = s.length
		s += '.'
	}
	while (s.length <= rs + 2) {
		s += '0'
	}
	return s
}
export function money (fen) {
	let num = fen
	if (num == null) return ''
	num = fen * 0.01 + ''
	num += ''
	const reg =
    num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
	num = num.replace(reg, '$1')
	num = toDecimal2(num)
	// return "￥" + num;
	return num
}
// 手机号、密码、身份证号解密
export const decryption = decryptionStr

export function money2 (fen) {
	let num = fen
	if (num == null) return ''
	if (num < 0) return ''
	num = fen * 0.01 + ''
	num += ''
	const reg =
    num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
	num = num.replace(reg, '$1')
	num = toDecimal2(num)
	// return "￥" + num;
	return num
}
export function money3 (fen) {
	let num = fen
	if (num == null) return ''
	if (num < 0) return ''
	num = fen * 0.01 + ''
	num += ''
	const reg =
    num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
	num = num.replace(reg, '$1')
	num = toDecimal2(num)
	return num
}
export function mchTypeChange (fen) {
	const mchtype = fen
	let value = ''
	const arr = [{
		id: 20,
		value: 'LN-506A'
	}, {
		id: 21,
		value: 'LN-6606'
	}, {
		id: 22,
		value: '手持机'
	}, {
		id: 23,
		value: 'LN-808'
	}, {
		id: 25,
		value: 'LN-Z02'
	}, {
		id: 26,
		value: 'LN-CG06'
	}, {
		id: 30,
		value: 'LN-6101'
	}, {
		id: 32,
		value: '出品机'
	}, {
		id: 34,
		value: '扫码收费机'
	}, {
		id: 35,
		value: 'LN-JL-01'
	}, {
		id: 36,
		value: 'LN-Z02'
	}, {
		id: 37,
		value: '核销机'
	}, {
		id: 38,
		value: '叫号机'
	}, {
		id: 39,
		value: 'LN-2200C'
	}, {
		id: 43,
		value: '留样机'
	}, {
		id: 44,
		value: '批量出品机'
	}, {
		id: 45,
		value: '电子菜排'
	}, {
		id: 46,
		value: '排菜平板'
	}, {
		id: 50,
		value: 'LN-809CS'
	}, {
		id: 51,
		value: 'AI菜品采集终端'
	}, {
		id: 52,
		value: 'LN-508A'
	}, {
		id: 53,
		value: 'LN-508A-S'
	}, {
		id: 41,
		value: '立式消费机'
	}, {
		id: 47,
		value: 'LN-XZ01'
	}, {
		id: 55,
		value: 'LN-807'
	}, {
		id: 56,
		value: 'LN-809'
	}, {
		id: 57,
		value: 'LN-809s'
	}]
	arr.forEach(item => {
		if (item.id == mchtype) {
			value = item.value
		}
	})
	return value
}
